import { ref } from 'vue';
import SuperTokens from 'supertokens-web-js';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import Session from 'supertokens-web-js/recipe/session';
import { apiDomain } from './useConstants';

SuperTokens.init({
  appInfo: {
    appName: 'Aristeem Admin',
    apiDomain
  },
  recipeList: [
    EmailPassword.init(),
    Session.init()
  ]
});

const user = ref(null);
const isRequested = ref(false);

function isInAllowedTier(_user) {
  return Boolean(_user?.value?.tier) && [ 'admin', 'seo', 'support', 'session-analytics' ].includes(_user.value.tier);
}

function setUser(newUser) {
  user.value = { ...newUser };
}

async function getUserAsync() {
  if (isRequested.value) {
    return user;
  }

  isRequested.value = true;

  const sessionExists = await Session.doesSessionExist();
  if (!sessionExists) {
    return user;
  }

  try {
    const response = await fetch(`${apiDomain}/api/user/auth/`);
    if (response.status !== 200) {
      return user;
    }

    const json = await response.json();
    setUser(json);

  } catch (error) {
    console.error('Error getting User', error);
  }

  return user;
}

async function doesSessionExist() {
  if (await Session.doesSessionExist()) {
    if (!user.value) {
      isRequested.value = false;
      await getUserAsync();
    }

    return isInAllowedTier(user);
  }
  return false;
}

async function signOut() {
  user.value = null;
  await Session.signOut();
}

async function signIn(email, password) {
  if (await Session.doesSessionExist()) {
    await signOut();
  }

  let response;
  try {
    response = await EmailPassword.signIn({
      formFields: [
        {
          id: 'email',
          value: email
        },
        {
          id: 'password',
          value: password
        }
      ]
    });
  } catch (error) {
    return { success: false, error: error.message };
  }

  if (response?.status === 'OK') {
    isRequested.value = false;
    await getUserAsync();

    if (isInAllowedTier(user)) {
      return { success: true };
    }

    return { success: false, error: 'Who are you, warrior?' };
  }

  // known statuses are: OK, WRONG_CREDENTIALS_ERROR, FIELD_ERROR
  return { success: false, error: response?.status };
}

async function doesEmailExist(email) {
  let response;
  try {
    response = await EmailPassword.doesEmailExist(email);
  } catch (error) {
    return { success: false, error: error.message };
  }

  if (response.status === 'OK') {
    return { success: true, doesExist: response.doesExist };
  }

  return { success: false, error: 'UNKNOWN_RESPONSE' };
}

function getUser() {
  if (!isRequested.value) {
    getUserAsync();
  }

  return user;
}

function isAdmin() {
  return user.value?.tier === 'admin' || false;
}

export {
  getUser,
  getUserAsync,
  doesSessionExist,
  doesEmailExist,
  signIn,
  signOut,
  isAdmin
};
